import { useContext } from "react";

import { AgendaItemContext } from "./AgendaItemContext";

export function useAgendaItem() {
  const context = useContext(AgendaItemContext);
  if (!context) {
    throw new Error("useAgendaItem must be used within a AgendaItemProvider");
  }
  return context;
}
